module.exports = __webpack_public_path__ + "img/logo_full.8fa9cac9.png";